import { useEffect } from 'react';
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AuthProvider } from './context/AuthContext';
import { CartProvider } from './context/CartContext';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Chatbot from './components/Chatbot';
import WhatsAppButton from './components/WhatsAppButton';
import Home from './pages/Home';
import Catalog from './pages/Catalog';
import ProductDetail from './pages/ProductDetail';
import Login from './pages/Login';
import Cart from './pages/Cart';
import Contact from './pages/Contact';
import About from './pages/About';
import Profile from './pages/Profile';
import Admin from './pages/Admin';
import Settings from './pages/Settings';
import Quotes from './pages/Quotes';
import Promotions from './pages/Promotions';
import AdminPromotions from './pages/AdminPromotions';
import Checkout from './pages/Checkout';
import CheckoutResult from './pages/CheckoutResult';
import AdminOrders from './pages/AdminOrders';
import AdminCategories from './pages/AdminCategories';
import AdminMetrics3D from './pages/AdminMetrics3D';
import Catalog3D from './pages/Catalog3D';
import MyOrders from './pages/MyOrders';
import './App.css';

function App() {
  useEffect(() => {
    // Smooth scroll setup
    document.documentElement.classList.add('lenis');
    
    // Remover badge "Made with Emergent"
    const removeBadge = () => {
      const badges = document.querySelectorAll('a[href*="emergentagent.com"], [class*="emergent"], div[style*="z-index: 9999"]');
      badges.forEach(el => {
        if (el.textContent?.includes('Emergent') || el.textContent?.includes('Made with')) {
          el.style.display = 'none';
          el.remove();
        }
      });
    };
    
    // Executar várias vezes para garantir que pegue o badge quando ele for injetado
    removeBadge();
    const interval = setInterval(removeBadge, 1000);
    setTimeout(() => clearInterval(interval), 10000);
    
    return () => clearInterval(interval);
  }, []);

  return (
    <AuthProvider>
      <CartProvider>
        <BrowserRouter>
          <div className="App min-h-screen flex flex-col">
            <Navbar />
            <main className="flex-1">
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/catalogo" element={<Catalog />} />
                <Route path="/produto/:id" element={<ProductDetail />} />
                <Route path="/login" element={<Login />} />
                <Route path="/carrinho" element={<Cart />} />
                <Route path="/contato" element={<Contact />} />
                <Route path="/sobre" element={<About />} />
                <Route path="/perfil" element={<Profile />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/admin/configuracoes" element={<Settings />} />
                <Route path="/admin/orcamentos" element={<Quotes />} />
                <Route path="/admin/promocoes" element={<AdminPromotions />} />
                <Route path="/admin/pedidos" element={<AdminOrders />} />
                <Route path="/admin/categorias" element={<AdminCategories />} />
                <Route path="/admin/metricas-3d" element={<AdminMetrics3D />} />
                <Route path="/catalogo-3d" element={<Catalog3D />} />
                <Route path="/promocoes" element={<Promotions />} />
                <Route path="/checkout" element={<Checkout />} />
                <Route path="/checkout/success" element={<CheckoutResult status="success" />} />
                <Route path="/checkout/pending" element={<CheckoutResult status="pending" />} />
                <Route path="/checkout/failure" element={<CheckoutResult status="failure" />} />
                <Route path="/meus-pedidos" element={<MyOrders />} />
              </Routes>
            </main>
            <Footer />
            <Chatbot />
            <WhatsAppButton />
            <Toaster position="top-right" richColors />
          </div>
        </BrowserRouter>
      </CartProvider>
    </AuthProvider>
  );
}

export default App;